<template>
    <div style="width:100%;heigh:100%;" id='device-group'>
        <div style="position: relative;top: -8px;">
            <el-button :disabled="disabledAdd" type="primary" @click="addItem"  size="mini">新增</el-button>
            <el-button :disabled="expands.length==0" @click="showEditDialog"  type="primary" size="mini">工作日历</el-button>
        </div>             
        <!--设备组管理开始-->
        <el-table :data="tableData"  style="width: 100%" border height="196" @row-click='loadDeviceListByGroupId' :row-style="rowClass" @selection-change="handleSelectionChange">
            <el-table-column type="selection"  width="55"></el-table-column>
            <el-table-column prop="groupCode" label="设备组编码">
                <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" v-model="scope.row.groupCode" placeholder="设备组编码"></el-input>
                    <span v-else>{{scope.row.groupCode}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="groupName" label="设备组名称" >
                <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" v-model="scope.row.groupName" placeholder="设备组名称"></el-input>
                    <span v-else>{{scope.row.groupName}}</span>
                </template>
            </el-table-column>
			<el-table-column prop="description" label="设备组描述" >
                <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" v-model="scope.row.description" placeholder="设备组描述"></el-input>
                    <span v-else>{{scope.row.description}}</span>
                </template>
            </el-table-column>
			<el-table-column prop="remark" label="备注" >
                <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" v-model="scope.row.remark" placeholder="备注"></el-input>
                    <span v-else>{{scope.row.remark}}</span>
                </template>
            </el-table-column>
			
            <el-table-column label="操作" >
                <template slot-scope="scope">
                    <el-button v-if="!scope.row.isEdit&&permission.btn_deviceGroup_updateDeviceGroup" @click="updateDevicGroupStatus(scope.row,scope.$index)" type="text" size="small">编辑</el-button>
                    <el-button v-if="scope.row.isEdit&&!scope.row.isAdd&&permission.btn_deviceGroup_updateDeviceGroup" @click="updateDevicGroup(scope.row)" type="text" size="small">保存</el-button>
                    <el-button v-if="scope.row.isAdd&&permission.btn_deviceGroup_addDeviceGroup" @click="addDevicGroup(scope.row,scope.$index)" type="text" size="small">保存新增</el-button>
                    <el-button @click="deleteDeviceGroup(scope.row,scope.$index)"   type="text" size="small" >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--设备组管理结束-->

        <!--设备组管理开始-->
        <div class="title" style="margin:15px 0 8px 0;">设备组对应设备</div>
        <el-table :data="deviceInfo" stripe style="width: 100%" border height="196">
            <el-table-column label="序号" width="55">
                <template slot-scope="scope">
                    {{scope.$index+1}}
                 </template>
            </el-table-column>
            <el-table-column prop="groupCode" label="设备名称">
                <template slot-scope="scope">
                    <el-select popper-class='select_device_width'  clearable remote filterable :remote-method="query=>{remoteMethod(query,'',scope)}" 
                        :loading="loading" @change="deviceSelect($event,scope.$index)" v-model="scope.row.deviceId" placeholder="设备名称">
                        <el-option :title="item.deviceName"  v-for="item in deviceList[scope.$index]" :key="item.id"  :label="item.deviceName" :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="groupName" label="设备编码" >
                <template slot-scope="scope">
                    <el-select popper-class='select_device_width'  clearable remote filterable :remote-method="query=>{remoteMethod('',query,scope)}" 
                        :loading="loading" @change="deviceSelect($event,scope.$index)" v-model="scope.row.deviceId" placeholder="设备编码">
                        <el-option :title="item.deviceCode"  v-for="item in deviceList[scope.$index]" :key="item.id"  :label="item.deviceCode" :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="scope.$index==(deviceInfo.length-1)&&scope.row.deviceId" @click="addDeviceInfoItem(scope.row,scope.$index)" type="text" size="small">新增</el-button>
                    <el-button @click="deleteDeviceInfoItem(scope.$index)"  type="text" size="small" >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--设备组管理结束-->

        <!--设备组工作日历查询开始-->
        <div style="border:1px solid #ccc; margin-top:26px" class="device-calendar">
            <div style=" margin:10px 3%">
            <!-- <h4 style="text-align: center">设备组工作日历查询</h4> -->
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="">
                        <span class="title">设备组编号：</span>
                        <span class="value">{{selectGroup.groupCode}}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="">
                        <span class="title">设备组名称：</span>
                        <span class="value">{{selectGroup.groupName}}</span>
                    </div>
                </el-col> 
                <el-col :span="12" >
                    <span class="title" style="display: inline-block;">日期：</span>
                    <div class="value time-range" style="width:330px;display: inline-block;" prop="date">
                        <el-date-picker :picker-options="{disabledDate(time) {return time.getTime() > new Date(selectGroup.endDate).getTime()},}" :clearable="false" style="width: 130px; display: inline-block;" v-model="selectGroup.beginDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                        <span style="margin:0 8px">至</span>
                        <el-date-picker :picker-options="{disabledDate(time) {return time.getTime() < new Date(selectGroup.beginDate).getTime()-24*60*60*1000},}" :clearable="false" style="width: 130px; display: inline-block;" v-model="selectGroup.endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                    
                </el-col>
                <el-col :span="4">
                    <el-button @click="loadShiftByGroupId" size="mini" type="primary" >查 询</el-button>
                </el-col>
            </el-row>
            <el-table :data="shiftList" stripe style="width: 100%" border height="196">
                <el-table-column prop="calDate" label="日期"></el-table-column>
                <el-table-column prop="dayOfWeek" label="周几" :formatter="parseWeek"></el-table-column>
                <el-table-column prop="shiftNames" label="班次名称" ></el-table-column>
                <el-table-column prop="beginDate" label="上班时间" ></el-table-column>
                <el-table-column prop="endDate" label="下班时间" ></el-table-column>
            </el-table>
            </div>
        </div>
        <!--设备组工作日历查询结束-->

        <!--编辑窗口开始-->
        <el-dialog title="编辑设备组日历" @close="closeEditDialog" :visible.sync="editDialogVisible" :width="span==5?'42%':'68%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="changeForm" class="addForm">
                <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title">日期：</span>
                            <el-form-item class="value time-range" style="width:300px" >
                                <el-date-picker :picker-options="{disabledDate(time) {return time.getTime() > new Date(addForm.endDate).getTime()},}" :clearable="false" style="width: 130px; display: inline-block;" v-model="addForm.beginDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                                <span style="margin:0 8px">至</span>
                                <el-date-picker :picker-options="{disabledDate(time) {return time.getTime() < new Date(addForm.beginDate).getTime()-24*60*60*1000},}" :clearable="false" style="width: 130px; display: inline-block;" v-model="addForm.endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24" >
                        <div class="">
                            <span class="title" style="margin-left: -14px;width: 84px;">上班天数：</span>
                            <el-checkbox-group style="display:inline-block" v-model="checkedList" @change="handleCheckedCitiesChange">
                                <el-checkbox v-for="item in checkList" :label="item.value" :key="item.value">{{item.key}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-table :data="selectShiftList" stripe style="width: 100%" border >
                        <el-table-column  label="班次名称">
                            <template slot-scope="scope">
                                <el-select popper-class='select_device_width'  clearable  filterable v-model="scope.row.shiftId" placeholder="班次名称">
                                    <el-option :title="item.shiftName"  v-for="item in configShiftList" :key="item.id"  :label="item.shiftName" :value="item.id"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column  label="班次编码">
                            <template slot-scope="scope">
                                <el-select popper-class='select_device_width'  clearable  filterable v-model="scope.row.shiftId" placeholder="班次编码">
                                    <el-option :title="item.shiftCode"  v-for="item in configShiftList" :key="item.id"  :label="item.shiftCode" :value="item.id"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="groupName" label="上班时间" >
                            <template slot-scope="scope">
                               <el-select popper-class='select_device_width'  clearable  filterable v-model="scope.row.shiftId" placeholder="上班时间">
                                    <el-option :title="item.beginDate"  v-for="item in configShiftList" :key="item.id"  :label="item.beginDate" :value="item.id"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="groupName" label="下班时间" >
                            <template slot-scope="scope">
                               <el-select popper-class='select_device_width'  clearable  filterable v-model="scope.row.shiftId" placeholder="下班时间">
                                    <el-option :title="item.endDate"  v-for="item in configShiftList" :key="item.id"  :label="item.endDate" :value="item.id"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right">
                            <template slot-scope="scope">
                                <el-button v-if="scope.$index==(selectShiftList.length-1)&&scope.row.shiftId" @click="addShiftItem" type="text" size="small">新增</el-button>
                                <el-button v-if="scope.$index!=0" @click="deleteShiftItem(scope.$index)"  type="text" size="small" >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updateCalendar()">确 定</el-button>
                <el-button @click="closeEditDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!--编辑窗口结束-->
    </div>
</template>

<script>
import CommonUtils from '../../util/CommonUtils'
export default {
    name: 'DeviceGroup',
    data() {
        return {
            configShiftList:[],
            selectShiftList:[{
                shiftId:null
            }],
            deviceGroupId:null,
            deviceListBase:[],
            deviceInfo:[],
            disabledAdd:false,
            selectGroup:{
                groupName:'',
                groupCode:'',
                beginDate:'',
                endDate:''
            },
            shiftList:[],
            loading:false,
            deviceList:[],
            deviceListOfGroup:[],
            editDialogVisible:false,
            selectYell:'2020',
            addForm:{
                beginDate:'',
                endDate:'',
            },
            dataList:[],
            copyList:[],
			startTime:'',
			endTime:'',
			checkedList: [],
			checkList: [
				{ key: '星期一', value: 1 }, 
				{ key: '星期二', value: 2 }, 
				{ key: '星期三', value: 3 },
				{ key: '星期四', value: 4 },
				{ key: '星期五', value: 5 }, 
				{ key: '星期六', value: 6 },
				{ key: '星期天', value: 0 }
			],
            W: false,
            rules: {
                description: [
                    { required: true, message: '请输入节假日名称', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (dayList.includes(value) && !that.addForm.readOnly) {
                                callback(new Error('自定义节假日名称不可和法定节假日名称相同'))
                            } else {
                                callback()
                            }
                        }, trigger: 'blur'
                    }
                ],
                date: [
                    { required: true, message: '请选择放假时间', trigger: 'blur' }
                ],
                checkedList: [
                    { required: true, message: '上班天数不能为空', trigger: 'blur' }
                ],
                time: [
                    { required: true, message: '上下班时间不能为空', trigger: 'blur' }
                ]
            },
            addDialogVisible: false,
            tableData: [],
            permission: JSON.parse(localStorage.getItem("permission")),
            year: new Date().getFullYear(),
            expands:[]
        }
    },
    mounted: async function () {
        this.loadDeviceGroupList()
        this.deviceListBase = await this.loadDeviceList()
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
    },
    computed: {
        span() {
            return this.W ? 5 : 7
        }
    },
    methods: {
        //加载设备组列表
        async loadDeviceGroupList(){
            let res = await this.$RequestUtil.getAsync({url: '/api/deviceGroup/listDeviceGroup',type: 'sync',params: {},});
            if (res.code == 0) {
                res.data.forEach(item=>{
                    item.isEdit = false
                    item.isAdd = false
                })
                this.tableData = res.data
                this.disabledAdd = false
            } else {
                this.$message.error(res.message || res.msg)
            }    
        },
        //删除设备组
        deleteDeviceGroup(rowData,index){
            if(!rowData.id){
                this.tableData.splice(index,1)
                this.disabledAdd = false
                return
            }
            this.$confirm(`此操作将会删除此设备组,是否继续?`, '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/deviceGroup/deleteDeviceGroup',
                    type:'sync',
                    params:{
                        id:rowData.id,
                    },
                    success:async (res)=>{
                        if(res.code==0){
                            await this.loadDeviceGroupList()
                            if(rowData.id==this.deviceGroupId){
                                this.selectGroup = {}
                                this.deviceGroupId = null
                                this.deviceInfo = [{deviceId:null}]
                            }
                            this.$message.success('删除成功')
                        }else{
                            this.$message.error(res.msg||res.message)
                        }
                    }
                })
            })
        },
        //新增设备组
        addDevicGroup(rowData,fn){
            if(!rowData.groupCode){
                this.$message.warning('设备组编码不能为空')
                return 
            }
            if(!rowData.groupName){
                this.$message.warning('设备组名称不能为空')
                return 
            }
            this.$RequestUtil.post({
                url: '/api/deviceGroup/addDeviceGroup',
                type: 'sync',
                params: {
                    groupCode:rowData.groupCode,
                    groupName:rowData.groupName,
                    description:rowData.description,
                    remark:rowData.remark
                },
                success: async (res) => {
                    if (res.code == 0) {
                       await this.loadDeviceGroupList()
                       if(fn){
                           fn()
                       }
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },
        addItem(){
            this.tableData.push({
                isEdit:true,
                isAdd:true
            })
            this.disabledAdd = true
        },
        //修改设备组
        updateDevicGroup(rowData,fn){
            if(rowData.groupCode.length>10){
                this.$message.warning('设备组编码长度不能大于10')
                return 
            }else if(rowData.groupName.length > 20){
                this.$message.warning('设备组编码名称不能大于20')
                return 
            }else if(rowData.description.length>50){
                this.$message.warning('设备组描述长度不能大于50')
                return 
            }else if(rowData.remark.length>100){
                this.$message.warning('备注长度不能大于100')
                return 
            }
            else{
                this.$RequestUtil.post({
                    url: '/api/deviceGroup/updateDeviceGroup',
                    type: 'sync',
                    params: {
                        groupCode:rowData.groupCode,
                        groupName:rowData.groupName,
                        description:rowData.description,
                        remark:rowData.remark,
                        id:rowData.id
                    },
                    success: async (res) => {
                        if (res.code == 0) {
                        await this.loadDeviceGroupList()
                        fn&&fn()
                        } else {
                            this.$message.error(res.message || res.msg)
                        }
                    }
                });
            }
        },

        //获取某个设置组设备列表
        loadDeviceListByGroupId(rowData){
            if(rowData.isEdit){
                return
            }
            this.deviceGroupId = rowData.id
            this.selectGroup = rowData
            this.$RequestUtil.get({
                url: '/api/deviceGroup/listDeviceIdByDeviceGroupId',
                type: 'sync',
                params: {
                    deviceGroupId:rowData.id
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.shiftList = []
                        if(res.data.length==0){
                            this.deviceInfo = [{
                                deviceId:null
                            }]
                            this.deviceList[0] = CommonUtils.cloneObj(this.deviceListBase) 
                        }else{
                            let arr = []
                            
                            
                            res.data.forEach(async (item,index)=>{
                                arr.push({
                                    deviceId:item
                                })
                                let find = this.deviceListBase.find(f=>f.id==item)
                                if(find){
                                    this.deviceList[index] = CommonUtils.cloneObj(this.deviceListBase)
                                }else{
                                    this.$set(this.deviceList,index,await this.loadDeviceList('','',[],item))
                                }
                            })
                            this.deviceInfo = arr
                            
                        }
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },
        rowClass({row, columnIndex}){
            if(row.id==this.deviceGroupId){
                return { "background-color": "rgb(109, 183, 238)",cursor: 'pointer' }
            }else{
                return {cursor: 'pointer'}
            }
        },
        addDeviceInfoItem(){
            this.deviceInfo.push({
                deviceId:null
            })
            let len = this.deviceInfo.length -1
            this.deviceList[len] = CommonUtils.cloneObj(this.deviceListBase)
        },

        deleteDeviceInfoItem(index){
            if(this.deviceInfo[index].deviceId){
                this.deviceInfo.splice(index,1)
                this.deviceList.splice(index,1)
                let deviceIds = this.deviceInfo.map(item=>item.deviceId).filter(item=>item)
                this.updateDeviceListByGroupId(this.deviceGroupId,deviceIds)
            }else{
                this.deviceInfo.splice(index,1)
                this.deviceList.splice(index,1)
            }
        },

        //更新设备组设备列表
        updateDeviceListByGroupId(deviceGroupId,deviceIds){
            this.$RequestUtil.post({
                url: '/api/deviceGroup/updateDeviceGroupCorrespondDevice',
                type: 'sync',
                params: {
                    deviceGroupId,
                    deviceIds
                },
                success: (res) => {
                    if (res.code == 0) {
                        let rowData= {
                            id:this.deviceGroupId,
                            ...this.selectGroup
                        }
                        this.loadDeviceListByGroupId(rowData)
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },

        
        updateDevicGroupStatus(rowData,index){
            let find = this.tableData.find(item=>item.isEdit)
            if(find){
                if(!find.groupCode){
                    this.$message.warning('当前编辑项设备组编码为空，请先输入设备组编码保存后再编辑其他项')
                    return 
                }
                if(!find.groupName){
                    this.$message.warning('当前编辑项设备组名称为空，请先输入设备组名称存后再编辑其他项')
                    return 
                }
                if(find.id){
                    this.updateDevicGroup(find,()=>{
                        this.tableData.forEach(item=>{
                            item.isEdit = false
                        })
                        this.disabledAdd = true
                        this.$set(this.tableData[index],'isEdit',true)
                    })
                }else{
                    this.addDevicGroup(find,()=>{
                        this.tableData.forEach(item=>{
                            item.isEdit = false
                        })
                        this.disabledAdd = true
                        this.$set(this.tableData[index],'isEdit',true)
                    })
                }
            }else{
                this.tableData.forEach(item=>{
                    item.isEdit = false
                })
                this.disabledAdd = true
                this.$set(this.tableData[index],'isEdit',true)
            }
            
        },

        deviceSelect(ev,index){
            let deviceIds = this.deviceInfo.map(item=>item.deviceId).filter(item=>item)
            this.updateDeviceListByGroupId(this.deviceGroupId,deviceIds)
        },

        async remoteMethod(deviceName,deviceCode,scope){
            let index = scope.$index
            let {deviceTypeId,isDisabled,deviceId} = scope
            let removeList = (this.deviceListOfGroup||[]).map(item=>item.deviceId).filter(item=>item&&item!=deviceId)
            this.loading = true
            let data = await this.loadDeviceList(deviceName,deviceCode,deviceTypeId,isDisabled,removeList)
            this.$set(this.deviceList,index,data)
            this.loading = false
        },

        async loadDeviceList(deviceName,deviceCode,removeDeviceList=[],addDeviceId){
            let {data, code, msg, message} = await this.$RequestUtil.postAsync({url: '/api/select/listDeviceSelect',type: 'sync', params: {deviceName,deviceCode,removeDeviceList,addDeviceId},})
            if (code == 0) {
                return data
            } else {
                this.$message.error(msg || message)
            }
        },

        //获取设备组工作日历
        loadShiftByGroupId(){
            if(!this.selectGroup.beginDate||!this.selectGroup.endDate){
                this.$message.warning('开始或结束时间不能为空')
                return false
            }
            if(!this.deviceGroupId){
                this.$message.warning('请先选择需要查询的设备组')
                return false
            }
            this.$RequestUtil.post({
                url: '/api/deviceGroup/listDeviceGroupDateShift',
                type: 'sync',
                params: {
                    deviceGroupId:this.deviceGroupId,
                    startDate:this.selectGroup.beginDate,
                    endDate:this.selectGroup.endDate,
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.shiftList = res.data
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },

        

        //加载班次列表
        loadShiftConfig(){
            this.$RequestUtil.get({
                url: '/api/calendarDate/listCalendarDateConfigShift',
                type: 'sync',
                params: {},
                success: (res) => {
                    if (res.code == 0) {
                       this.configShiftList = res.data
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },
        showEditDialog(){
            this.editDialogVisible = true
            this.loadShiftConfig()
        },
        addShiftItem(){
            this.selectShiftList.push({
                shiftId:null
            })
        },
        deleteShiftItem(index){
            this.selectShiftList.splice(index,1)
        },

        //返回一段时间内包含的星期数组
        getWeeksFromDate(startDate, endDate) {
            let beginDateObj = new Date(startDate);
            let endDateObj = new Date(endDate);
            let weeksArr = [];
            while (beginDateObj <= endDateObj) {//直到结束日期，跳出循环
                let weekNum = beginDateObj.getDay();
                weeksArr.push(weekNum);
                beginDateObj.setTime(beginDateObj.getTime() + 24 * 60 * 60 * 1000);//每次递增1天
            }
            weeksArr = [...new Set(weeksArr)].sort()
            return weeksArr;
        },

        handleCheckedCitiesChange() {
            if(!this.addForm.beginDate||!this.addForm.endDate){
                return false
            }
            let weeksArr = this.getWeeksFromDate(this.addForm.beginDate,this.addForm.endDate)
            let arr = []
            this.checkedList.forEach(item=>{
                if(!weeksArr.includes(item)){
                  arr.push(item)
                }
            })
            let isPass = true
            if(arr.length>0){
                let weekArrStr =  arr.map(item=>(this.checkList.find(f=>f.value==item)||{}).key)
                let str = weekArrStr.join('、 ')
                this.$message.warning(`${this.addForm.beginDate} —— ${this.addForm.endDate}不包含${str}`)
                this.checkedList = this.checkedList.filter(item=>!arr.includes(item))
                isPass = false
            }
            return isPass
        },

        handleSelectionChange(val) {
            this.expands = val.map(item=>item.id);
        },

        //检测默认班次是否存在冲突
        checkHasConflict(arr){
            let copyArr = CommonUtils.cloneObj(arr) 
            copyArr.forEach(item=>{
                item.startMinutes = this.hoursToMinutes(item.beginDate)
                item.endMinutes = this.hoursToMinutes(item.endDate)
            })
            copyArr = copyArr.sort((item1,item2)=>{
                return item1.startMinutes - item2.startMinutes
            })
            copyArr.forEach((item,index)=>{
                let next = copyArr[index+1]
                if(next){
                    if(item.endMinutes>next.startMinutes){
                        this.$message.error(`班次${item.shiftName}和班次${next.shiftName}选为默认班次时间存在冲突`)
                        hasConflict = true
                    }
                }
            })
        },

        updateCalendar(){
            let shiftIds = this.selectShiftList.map(item=>item.shiftId).filter(item=>item)
            if(shiftIds.length==0){
                this.$message.warning('设备组班次不能为空，请添加班次')
                return
            }
            if(this.checkedList.length==0){
                this.$message.warning('上班天数不能为空，请选择上班天数')
                return
            }
            
            if(shiftIds.length>[...new Set(shiftIds)].length){
                this.$message.warning('班次不可重复选择')
                return
            }

            //检测开始时间是否存在
            if(!this.addForm.beginDate){
                this.$message.warning('请选择开始时间')
                return
            }
            //检测结束时间是否存在
            if(!this.addForm.endDate){
                this.$message.warning('请选择结束时间')
                return
            }
            //检测勾选星期是否在时间段里面
            let isPass = this.handleCheckedCitiesChange()
            if(!isPass){
                return
            }
            // 检测班次是否冲突
            let arr = this.configShiftList.filter(item=>this.selectShiftList.includes(item.id))
            let hasConflict = this.checkHasConflict(arr)
            if(hasConflict){
                return false
            }
            this.$RequestUtil.post({
                url: '/api/deviceGroup/updateDeviceGroupDateShift',
                type: 'sync',
                params: {
                    beginDate:this.addForm.beginDate,
                    endDate:this.addForm.endDate,
                    workDay:this.checkedList,
                    deviceGroupIds:this.expands,
                    shiftIds,
                    isCheck:true
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.$message.success('修改成功!')
                        this.closeEditDialog()
                    }else if(res.code == 1){
                        this.$confirm(`${res.data}`, '提示', {
                            cancelButtonClass: "btn-custom-cancel",
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$RequestUtil.post({
                                url: '/api/deviceGroup/updateDeviceGroupDateShift',
                                type: 'sync',
                                params: {
                                    beginDate:this.addForm.beginDate,
                                    endDate:this.addForm.endDate,
                                    workDay:this.checkedList,
                                    deviceGroupIds:this.expands,
                                    shiftIds,
                                    isCheck:false
                                },
                                success: (res) => {
                                    if (res.code == 0) {
                                        this.$message.success('修改成功!')
                                        this.closeEditDialog()
                                    }else {
                                        this.$message.error(res.message || res.msg)
                                    }
                                }
                            })
                        })
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },

        closeEditDialog(){
            this.editDialogVisible = false
            this.addForm.beginDate = ''
            this.addForm.endDate = ''
            this.checkedList = []
            this.selectShiftList = [{}]
        },

        parseWeek(rowData){
            if(rowData.dayOfWeek!=null&&rowData.dayOfWeek!=undefined){
                let str = ''
                switch(rowData.dayOfWeek){
                    case 0:
                        str = '周日'
                    break;
                    case 1:
                        str = '周一'
                    break;
                    case 2:
                        str = '周二'
                    break;
                    case 3:
                        str = '周三'
                    break;
                    case 4:
                        str = '周四'
                    break;
                    case 5:
                        str = '周五'
                    break;
                    case 6:
                        str = '周六'
                    break;
                }
                return str
           }
        },
       
        search: function () {
            this.$RequestUtil.get({
                url: '/api/calendarDate/getAllCalendarDate',
                type: 'sync',
                params: {
                    year: this.year
                },
                success: (res) => {
                    if (res.code == 0) {
                        
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        }
        
    },
}
</script>
<style>
.select_device_width{
    width: 200px;
}
#device-group .el-radio-button--small .el-radio-button__inner{
    width: 300px;
}
.time-range .el-form-item__content{
    width: 300px;
}



#device-group .el-table tr {
    height: 39px !important;
}
#device-group .el-table--small td {
    padding: 2px 0 !important;

}
#device-group .el-table--small th {
    height: 39px !important;
}
.import_upload > .el-upload-list {
    display: none;
}

#device-group .part-table .el-form-item {
    margin-bottom: 0px !important;
}

.table_searchbar .el-button--mini,
.el-button--mini.is-round {
    padding: 7px 10px;
}

.change-time .el-time-spinner .el-time-spinner__wrapper:nth-child(2) {
    display: none !important;
}

.change-time {
    width: 220px;
}
#device-group .el-date-editor.el-input, #device-group .el-date-editor.el-input__inner {
    width: 130px !important;
}
</style>
<style scoped>

.calendar-warp{
    margin:0 4.2% 10px 0;
    width: 13%;
    border: 1px dashed #000;
    text-align: center;
}
.calendar-title{
    text-align: center;
    margin: 8px 0;
}

.sub-text{
    line-height: 20px;
    /* display: inline-block; */
    width: 26px;
    /* border: 1px solid #000; */
    border-right: none;
    border-top: none;
    text-align: center;
    font-size: 12px;
}
.warp-heard .sub-text{
    /* border-top: 1px solid #000; */
}

.warp-body,.warp-heard{
    margin: 0 16px;
}


.scroll {
    max-height: 250px;
    overflow: hidden;
    overflow-y: auto;
    position: relative;
    top: -28px;
    /* scrollbar-width: none; */
}

.copy {
    background-color: transparent;
    background: rgb(64, 158, 255);
    border-color: #66b1ff;
    color: #fff;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    margin: 0;
    font-weight: 500;
    outline: none;
}

.copy:hover {
    outline: none;
}
.title {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.value{
   color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px; 
}
.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}

.el-row {
    margin-bottom: 20px;

    & :last-child {
        margin-bottom: 0;
    }
}

.table_searchbar {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
}

.import_upload {
    display: inline;
}

.page {
    display: flex;
    justify-content: flex-end;
}

.total_page {
    margin-top: 20px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}

.key {
    font-size: 16px;
    color: #c0c4cc;
    font-family: NotoSansHans-Regula;
    padding-right: 10px;
}



.addForm .value {
    display: inline-block;
    max-width: 220px;
}

.addForm .title {
    width: 70px;
    text-align: right;
    display: inline-block;
}

@media screen and (max-width: 1400px) {
    .device-calendar{
        margin-bottom: 30px;
    }
}

.color-blue {
    color: blue;
}

.el-icon-circle-close-outline:hover {
    color: red;
}

.delete {
    width: 18px;
    height: 19px;
    background-image: url("../../../static/img/del.png");
    cursor: pointer;
    background-repeat: no-repeat;
}

.delete:hover {
    background-image: url("../../../static/img/del-hover.png");
    background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/views/devicecare/deviceGroup.vue